import { gql, useMutation } from "@apollo/client";
import { MutationDeleteMediaFileArgs } from "../../__generated__/types";

const DELETE_MEDIA_FILE = gql`
  mutation DeleteMediaFile($_id: ID!) {
    deleteMediaFile(_id: $_id)
  }
`;

export const useDeleteMediaFileMutation = () => {
  const [deleteMediaFileMutation, { loading, error, data }] =
    useMutation(DELETE_MEDIA_FILE);

  const deleteMediaFile = async (args: MutationDeleteMediaFileArgs) => {
    try {
      const { data } = await deleteMediaFileMutation({
        variables: args,
      });
      return data?.deleteMediaFile;
    } catch (error) {
      console.error("Error deleting media file:", error);
      throw error;
    }
  };

  return {
    deleteMediaFile,
    loading,
    error,
    data,
  };
};
